<template>
  <div class="save-img-box">
    <div class="content-box" @click="saveImg">
      <img src="@/assets/html5/icon_download@2x.png" alt="">
      <span>{{$t('APP-FIELD-0138')}}</span>
    </div>

  </div>
</template>

<script>
  export default {
    name: "SaveImage",

    methods: {
      saveImg() {
        this.showMessageTip('请自行手动截图');
      }
    }
  }


</script>

<style lang="scss" scoped>
  .save-img-box {
    cursor: pointer;
    text-align: center;
    .content-box {
      display: inline-block;
    }
    img {
      width: 24px;
      margin-right: 10px;
      vertical-align: bottom;
    }
    span {
      font-family: Nunito-SemiBold;
      font-size: 16px;
      color: #0072D8;
      letter-spacing: 0.14px;
    }
  }
</style>